import React from "react";
import Layout from "../../components/layout/index";

import Hero from "../../components/cfs/Hero";
import Products from "../../components/cfs/Product1";
import Products2 from "../../components/cfs/Product2";
import SubscriptionOptions from "../../components/cfs/PricingCard";
import PageContainer from "../../components/PageContainer";

const CfsProduct = () => {
  return (
    <PageContainer
    title="Access Indian Private Company Financial Data, MCA Filings, and Charges | Venture Intelligence"
    description="Venture Intelligence provides Indian private company financial data, including MCA filings, charge details, and annual reports. Get Access and Insights Now."
    >
      <Layout>
        <Hero />
        <Products />
        <Products2 />
        <SubscriptionOptions />
      </Layout>
    </PageContainer>
  );
};

export default CfsProduct;
